<template>
  <tr class="text-left even:bg-primary-gray-100 h-18 divide-x divide-primary-gray-200">
    <slot />
  </tr>
</template>
